var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarningDialog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 48C37.7 48 48.5 37.2 48.5 24C48.5 10.8 37.7 0 24.5 0C11.3 0 0.5 10.8 0.5 24C0.5 37.2 11.3 48 24.5 48Z",
    fill: "#E32E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8003 32.0997C21.8003 30.6085 23.0091 29.3997 24.5003 29.3997C25.9915 29.3997 27.2003 30.6085 27.2003 32.0997C27.2003 33.5909 25.9915 34.7997 24.5003 34.7997C23.0091 34.7997 21.8003 33.5909 21.8003 32.0997Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0648 15.8863C21.9209 14.4479 23.0505 13.1997 24.4961 13.1997C25.9417 13.1997 27.0713 14.4479 26.9275 15.8863L25.9805 25.3564C25.9042 26.119 25.2625 26.6997 24.4961 26.6997C23.7298 26.6997 23.0881 26.119 23.0118 25.3564L22.0648 15.8863Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningDialog);
export default __webpack_public_path__ + "static/media/icon_warning_dialog.e886c538.svg";
export { ForwardRef as ReactComponent };